import * as _ from 'lodash';

import { ConceptResult } from '../../Shared/quill-marking-logic/src/main';
import { hashToCollection } from '../../Shared/index';
import { FormattedConceptResult, Question, ResponseAttempt } from '../interfaces/questions';
import { extractResponse } from './extractResponse';
import { embedQuestionNumbers } from '../../Shared/activityScoring';

export function getConceptResultsForQuestion(question: Question): FormattedConceptResult[]|undefined {
  const prompt = question.prompt.replace(/(<([^>]+)>)/ig, '').replace(/&nbsp;/ig, '');
  if (question.attempts && question.attempts.length) {
    const conceptResults = question.attempts.map((a, i) => getConceptResultsForAttempt(a, question, prompt, i))
    if (conceptResults && conceptResults.length) {
      return _.flatten(conceptResults)
    } else {
      return undefined
    }
  } else {
    return undefined
  }
}

function getConceptResultsForAttempt(attempt: ResponseAttempt, question: Question, prompt: string, index: number):FormattedConceptResult[] {
  const responseData = extractResponse(attempt);
  const answer = responseData.text;

  let conceptResults: ConceptResult[]|never = [];
  if (responseData) {
    const conceptResultObject = responseData.conceptResults || responseData.concept_results
    conceptResults = hashToCollection(conceptResultObject) || [];
  } else {
    conceptResults = [];
  }
  conceptResults = Array.isArray(conceptResults) ? conceptResults : _.values(conceptResults)
  if (conceptResults.length === 0) {
    conceptResults = [{
      conceptUID: question.concept_uid,
      correct: !!responseData.optimal
    }];
  }

  let directions = question.instructions

  let lastFeedback: string | undefined
  if (index > 0) {
    const previousAttempt = question.attempts[index - 1];
    const previousResponseData = extractResponse(previousAttempt);
    lastFeedback = previousResponseData.feedback;
  }

  const attemptNumber = index + 1
  return conceptResults.map((conceptResult: ConceptResult) => {
    const questionConceptUID = question.concept_uid || question.conceptID
    return {
      concept_uid: conceptResult.conceptUID,
      question_type: 'sentence-writing',
      metadata: lastFeedback ? {
        correct: conceptResult.correct ? 1 : 0,
        directions,
        lastFeedback,
        prompt,
        answer,
        attemptNumber,
        question_uid:  question.uid,
        question_concept_uid: questionConceptUID,
        cues: question.cues?.filter(Boolean)
      } : {
        correct: conceptResult.correct ? 1 : 0,
        directions,
        prompt,
        answer,
        attemptNumber,
        question_uid:  question.uid,
        question_concept_uid: questionConceptUID,
        cues: question.cues?.filter(Boolean)
      },
    }});
}

export function getNestedConceptResultsForAllQuestions(questions: Question[]) {
  return questions.map(questionObj => getConceptResultsForQuestion(questionObj));
}

export function getConceptResultsForAllQuestions(questions: Question[], startingNumber:number = 0): FormattedConceptResult[] {
  const nested = getNestedConceptResultsForAllQuestions(questions).filter(Boolean);
  const withKeys = embedQuestionNumbers(nested, startingNumber);
  return [].concat.apply([], withKeys); // Flatten array
}

export { calculateScoreFromConceptResults, embedQuestionNumbers } from '../../Shared/activityScoring';
